document.addEventListener('DOMContentLoaded', function () {
  // Helper: find the current section ID near the changed element
  function getSectionIdFrom(el) {
    var sec = el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }

  async function refreshPriceUI(sectionId, variantId) {
    try {
      var url = location.pathname +
        '?section_id=' + encodeURIComponent(sectionId) +
        '&variant='   + encodeURIComponent(variantId);

      var html = await fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); });

      var tmp = document.createElement('div');
      tmp.innerHTML = html;

      var fresh = tmp.querySelector('.new-price-wrapper');
      var current = document.querySelector('#shopify-section-' + CSS.escape(sectionId) + ' .new-price-wrapper');

      if (fresh && current) {
        current.replaceWith(fresh);
      }
    } catch (err) {
      console.error('[price] refresh failed', err);
    }
  }

    // Main listener – Dawn/OS2.0 dispatches this on variant change
    document.addEventListener('variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || !variant.id) return;

      // try to derive section id from the element that fired the event
      var sectionId =
        getSectionIdFrom(evt.target) ||
        getSectionIdFrom(document.querySelector('.new-price-wrapper'));

      if (!sectionId) {
        console.warn('[price] Could not determine sectionId.');
        return;
      }

      refreshPriceUI(sectionId, variant.id);
    });

    // Optional: fallback for themes that don’t emit `variant:change`
    // Watches the hidden variant id input and refreshes when it changes.
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (inp) {
      var last = inp.value;
      var sectionId = getSectionIdFrom(inp);
      if (!sectionId) return;

      var mo = new MutationObserver(function () {
        if (inp.value && inp.value !== last) {
          last = inp.value;
          refreshPriceUI(sectionId, inp.value);
        }
      });
      mo.observe(inp, { attributes: true, attributeFilter: ['value'] });
      // Also catch manual changes
      inp.addEventListener('change', function () {
        if (inp.value && inp.value !== last) {
          last = inp.value;
          refreshPriceUI(sectionId, inp.value);
        }
      });
    });



  // Attach click handler directly to all [data-sponser-amount] buttons
  var buttons = document.querySelectorAll('[data-sponser-amount]');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); // avoid form submit if inside a form

      // Scope to the same Shopify section as the clicked button
      var scope = btn.closest('[id^="shopify-section-"]') || document;

      // Read quantity
      var qtyEl = scope.querySelector('[data-sponser-qty]');
      if (!qtyEl) return;

      var raw = ('value' in qtyEl ? qtyEl.value : (qtyEl.textContent || '')).trim();
      var qty = parseInt(raw.replace(/[^\d]/g, ''), 10); // integers only
      if (!Number.isFinite(qty)) qty = 0;

      // ---- Calculations ----
      var totalMain = qty * 39;   // existing main variant price calc
      var totalCompare = qty * 103;
      var totalSubsidy = qty * 40;
      var totalGift = qty * 24;

      // Helper to keep existing prefix (currency / "- ")
      function setAmount(selector, amount) {
        var el = scope.querySelector(selector);
        if (!el) return;
        var current = (el.textContent || '').trim();
        var prefixMatch = current.match(/^(\D+)\s*/); // grab any leading non-digits
        var prefix = prefixMatch ? prefixMatch[1] : '';
        var display = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
        el.textContent = prefix + display;
      }

      // Update all targets
      setAmount('[data-main-variant-price]', totalMain);
      setAmount('[data-main-compare-price]', totalCompare);
      setAmount('[data-susbidy-price]', totalSubsidy); // in case of typo, keep both
      setAmount('[data-subsidy-price]', totalSubsidy);
      setAmount('[data-gift-price]', totalGift);
    });
  });



  const sections = Array.from(document.querySelectorAll('.animate-number'));
  if (!sections.length) return;

  // Find all counters across all matching sections
  const counters = sections.flatMap(section =>
    Array.from(section.querySelectorAll('[data-number-animate]'))
  );
  if (!counters.length) return;

  // Parse number while preserving prefix/suffix (e.g., "~80%" -> "~", 80, "%")
  const parseValue = (el) => {
    const text = (el.textContent || '').trim();
    const m = text.match(/([0-9]+(?:\.[0-9]+)?)/);
    const num = m ? parseFloat(m[1]) : 0;
    const prefix = m ? text.slice(0, m.index) : '';
    const suffix = m ? text.slice(m.index + m[0].length) : '';
    return { num, prefix, suffix };
  };

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Initialize counters
  counters.forEach((el) => {
    const { num, prefix, suffix } = parseValue(el);
    el.dataset.target = String(num);
    el.dataset.prefix = prefix;
    el.dataset.suffix = suffix;

    // Optional per-element controls:
    // data-count-duration="1500", data-count-decimals="1"
    if (!el.dataset.countDuration) el.dataset.countDuration = '1200';
    if (!el.dataset.countDecimals) el.dataset.countDecimals = (num % 1 !== 0 ? '1' : '0');

    el.textContent = `${prefix}0${suffix}`;
  });

  const animate = (el) => {
    const target = parseFloat(el.dataset.target || '0');
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = parseInt(el.dataset.countDuration || '1200', 10);
    const decimals = Math.max(0, parseInt(el.dataset.countDecimals || '0', 10));

    if (prefersReduced || duration <= 0 || target === 0) {
      el.textContent = `${prefix}${target.toFixed(decimals)}${suffix}`;
      return;
    }

    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = target * eased;
      const display = decimals ? current.toFixed(decimals) : Math.round(current);
      el.textContent = `${prefix}${display}${suffix}`;
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  // Observe each counter (works across many sections)
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (el.dataset.counted === '1') return;
        el.dataset.counted = '1';
        animate(el);
        io.unobserve(el);
      });
    }, { root: null, threshold: 0.3 });

    counters.forEach((el) => io.observe(el));
  } else {
    // Fallback
    const check = () => {
      counters.forEach((el) => {
        if (el.dataset.counted === '1') return;
        const r = el.getBoundingClientRect();
        const inView = r.top < window.innerHeight * 0.8 && r.bottom > 0;
        if (inView) {
          el.dataset.counted = '1';
          animate(el);
        }
      });
    };
    document.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }





});


//shopify notify button 

